import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Option, AfterschoolHour } from '../../../../../../../classes';
import { orderBy, groupBy, times, isMatch } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'schoolbelle-afterschool-compose',
  templateUrl: './afterschool-compose.component.html',
  styleUrls: ['./afterschool-compose.component.css']
})
export class AfterschoolComposeComponent implements OnInit {
  @Input() option:Option;
  possible_tags:string[] = [];
  newHour:AfterschoolHour;
  action = new EventEmitter();  

  constructor(
    private modalRef:BsModalRef
  ) { 
    // const survey = new Survey();
    // survey.type = 'afterschool';
    // survey.afterschool_possible_tags = ['1íë', '2íë', '3íë', '4íë', '5íë', '6íë'];
    // const question = new Question(survey, 'afterschool');
    // question.canHaveQuotaOptions = true;
    // this.option = new Option(question, 'afterschool');
    // this.option.text = 'ë°©ê³¼í';
    // this.option.accept = 10;
    // this.option.waitlist = 2;
    // this.option.tags = ['2íë', '3íë'];
    // this.option.hours = [
    //   {dayIndex:0, start:'09:30', end:'12:30'},
    //   {dayIndex:0, start:'15:30', end:'17:30'},
    //   {dayIndex:6, start:'15:30', end:'17:30'},
    // ];
  }

  ngOnInit() {
    this.possible_tags = this.option.question.survey.afterschool_possible_tags;
    this.initNewHourModel();

  }
  ok (data:any = true) {
    this.modalRef.hide(); 
    this.action.emit(data);
  }
  cancel () {
    this.modalRef.hide(); 
    this.action.emit(false);
  }  
  hasTag (tag) {
    return this.option.tags.includes(tag);
  }
  toggleTag (tag) {
    if (this.hasTag(tag)) {
      let tags = this.option.tags;
      tags.splice(tags.indexOf(tag), 1);
      this.option.tags = tags;
    }
    else {
      let tags = this.option.tags;
      tags.push(tag);
      tags = orderBy(tags, t=>this.possible_tags.indexOf(t), 'asc');
      this.option.tags = tags;
    }

  }
  get days () {
    
    const grouped = groupBy(this.option.hours, 'dayIndex');
    return times(7).map(i=> (i + 1) % 7 ).map(i=>grouped[i] || []);
  }
  addHour (hour:AfterschoolHour) {
    let hours = this.option.hours;
    hours.push(hour);
    hours = orderBy(hours, h=>(h.dayIndex + 1 % 7) + h.start, 'asc');
    this.option.hours = hours;
    this.initNewHourModel();
  }
  removeHour (hour:AfterschoolHour) {
    let hours = this.option.hours;
    console.log(hour, hours.findIndex(h=>isMatch(h, hour)));
    hours.splice(hours.findIndex(h=>isMatch(h, hour)), 1);
    this.option.hours = hours;
  }
  private initNewHourModel () {
    this.newHour = {dayIndex:undefined, start:'', end:''};
  }
  trackByIndex (index:number) {
    return index;
  }

}
